'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Dot = require('../atoms/Dot'),
    { PropTypes } = React;

require('./Dots.less');

var Dots = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin],

  propTypes: {
    activeIndex: PropTypes.number.isRequired,
    requestActiveIndexChange: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    style: PropTypes.object
  },

  render() {
    var { count, activeIndex, style } = this.props,
        dots = [];

    for (var i = 0; i < count; i++) {
      dots.push(
        <Dot key={i}
             active={i === activeIndex}
             onClick={this.handleDotClick.bind(this, i)} />
      );
    }

    return (
      <div className={this.getClassName()}
           style={style}>
        {dots}
      </div>
    );
  },

  handleDotClick(index) {
    this.props.requestActiveIndexChange(index);
  }
});

module.exports = Dots;


/** WEBPACK FOOTER **
 ** ./molecules/Dots.jsx
 **/